<template>
  <font-awesome-icon icon="copy"
                     class="text-md text-icon hover:text-icon-hover transition duration-200 cursor-pointer"
                     @click="copy"/>
</template>

<script>
import copyTextToClipboard from "@/utilities/copyTextToClipboard";

export default {
  name: "CopyIcon",
  props: {
    value: {
      type: String
    }
  },
  methods: {
    async copy() {
      try {
        const copied = await copyTextToClipboard(this.value)
        if (copied) {
          this.$toasted.success(this.$t('copySuccess'))
        }
      } catch (err) {
        console.log(err)
      }
    }
  },
  i18n: {
    messages: {
      en: {
        copySuccess: 'Copied successfully'
      },
      ru: {
        copySuccess: 'Успешно скопировано'
      }
    }
  }
}
</script>

<style scoped>

</style>